var _defs, _g, _circle, _g2;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgVolcanes(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Capa_1",
    "data-name": "Capa 1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 72,
    height: 72,
    viewBox: "0 0 72 72",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, "\r\n      .cls-1, .cls-3 {\r\n        fill: none;\r\n      }\r\n\r\n      .cls-2 {\r\n        clip-path: url(#clip-path);\r\n      }\r\n\r\n      .cls-3 {\r\n        stroke: #656062;\r\n        stroke-miterlimit: 10;\r\n        stroke-width: 0.64503px;\r\n      }\r\n\r\n      .cls-4 {\r\n        fill: #fff;\r\n      }\r\n\r\n      .cls-5 {\r\n        fill: #656062;\r\n      }\r\n    "), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M100.63869-48.0029A28.55106,28.55106,0,0,1,99.502-56,28.4989,28.4989,0,0,1,128-84.498,28.49892,28.49892,0,0,1,156.498-56,28.4977,28.4977,0,0,1,128-27.502a28.48424,28.48424,0,0,1-24.39261-13.7529"
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    className: "cls-2"
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("line", {
    className: "cls-3",
    x1: 42.69339,
    y1: -87.6348,
    x2: 154.24319,
    y2: 23.915
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-3",
    x1: 44.53519,
    y1: -89.4746,
    x2: 156.084,
    y2: 22.0742
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-3",
    x1: 46.375,
    y1: -91.3164,
    x2: 157.92579,
    y2: 20.2334
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-3",
    x1: 48.21679,
    y1: -93.1572,
    x2: 159.76759,
    y2: 18.3926
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-3",
    x1: 50.05759,
    y1: -94.998,
    x2: 161.60839,
    y2: 16.5508
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-3",
    x1: 51.90039,
    y1: -96.8398,
    x2: 163.44919,
    y2: 14.709
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-3",
    x1: 53.74119,
    y1: -98.6816,
    x2: 165.291,
    y2: 12.8691
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-3",
    x1: 55.582,
    y1: -100.5234,
    x2: 167.13279,
    y2: 11.0264
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-3",
    x1: 57.42379,
    y1: -102.3643,
    x2: 168.97459,
    y2: 9.1855
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-3",
    x1: 59.26459,
    y1: -104.2051,
    x2: 170.81449,
    y2: 7.3447
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-3",
    x1: 61.10639,
    y1: -106.0469,
    x2: 172.65629,
    y2: 5.5029
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-3",
    x1: 62.94729,
    y1: -107.8887,
    x2: 174.498,
    y2: 3.6621
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-3",
    x1: 64.78909,
    y1: -109.7295,
    x2: 176.33789,
    y2: 1.8213
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-3",
    x1: 66.62989,
    y1: -111.5703,
    x2: 178.17969,
    y2: -0.0195
  })))), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    className: "cls-4",
    cx: 36,
    cy: 36,
    r: 35
  })), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "cls-5",
    d: "M40.60275,16.34q-.08016,0-.16037.00345A4.99716,4.99716,0,0,0,35.97116,13.61a5.04772,5.04772,0,0,0-4.34466,2.50462l-.06867-.00083a3.83394,3.83394,0,1,0,0,7.66788.6037.6037,0,1,0,0-1.2074,2.62644,2.62644,0,0,1,0-5.25288c.37126,0,.76779.09794.96412-.31786a3.81463,3.81463,0,0,1,6.99028.20914c.19612.48856.68692.33489,1.09052.33489a2.62646,2.62646,0,0,1,0,5.25292.60368.60368,0,1,0,0,1.20736,3.83392,3.83392,0,0,0,0-7.66784Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-5",
    d: "M28.62114,25.80884a.604.604,0,0,0-.854,0,1.59692,1.59692,0,0,1-2.25846-2.2583c.23653-.23637.4918-.44081.35665-.81861a2.418,2.418,0,0,1,.56335-2.51414.60385.60385,0,0,0-.854-.854,3.63393,3.63393,0,0,0-.96333,3.37687,2.80477,2.80477,0,0,0,.04308,3.92153c-.13231-.1321-.26417-.264.00042.00059.26442.26442.13269.13273.00041.00041a2.80474,2.80474,0,0,0,3.96582-.00058A.60376.60376,0,0,0,28.62114,25.80884Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-5",
    d: "M47.52211,22.74088A3.63425,3.63425,0,0,0,46.559,19.364a.60377.60377,0,1,0-.854.85378,2.41891,2.41891,0,0,1,.56335,2.51414c-.13515.3778.11991.58224.35649.81861a1.597,1.597,0,0,1-2.25851,2.25851.6037.6037,0,1,0-.85378.85374,2.80453,2.80453,0,0,0,4.00952-3.92191Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-5",
    d: "M34.2057,21.98141a.60371.60371,0,1,0-.92695.77371,5.94624,5.94624,0,0,1,1.27041,3.76969.60378.60378,0,1,0,1.20756,0A7.07071,7.07071,0,0,0,34.2057,21.98141Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-5",
    d: "M32.36749,20.572a4.23086,4.23086,0,0,0-1.70552-.36015.6037.6037,0,0,0,0,1.20739,3.03326,3.03326,0,0,1,1.22163.25893.60369.60369,0,1,0,.48389-1.10617Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-5",
    d: "M38.88607,21.84381a.60381.60381,0,0,0-.85174.062,7.12733,7.12733,0,0,0-1.61528,4.619.6038.6038,0,1,0,1.2076,0,5.90772,5.90772,0,0,1,1.32119-3.82946A.60371.60371,0,0,0,38.88607,21.84381Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-5",
    d: "M41.51384,20.21188a4.2261,4.2261,0,0,0-1.59068.31174.60382.60382,0,0,0,.45259,1.11962,3.02058,3.02058,0,0,1,1.13789-.22376.6038.6038,0,0,0,.0002-1.2076Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-5",
    d: "M36.088,17.28884a.60391.60391,0,0,0-.60376.604v3.48072a.60378.60378,0,1,0,1.20756,0V17.89281A.60405.60405,0,0,0,36.088,17.28884Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "cls-5",
    d: "M18.69376,38.61148h5.7689a.618.618,0,0,0,0-1.236h-5.7689a1.03017,1.03017,0,1,1,0-2.06034h8.07635a.618.618,0,1,0,0-1.236H18.69376a2.26621,2.26621,0,1,0,0,4.53241Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-5",
    d: "M38.47232,57.154H19.51786a1.0313,1.0313,0,0,1-1.03017-1.03v-.41214a3.68148,3.68148,0,0,1,3.38053-3.91462,3.35518,3.35518,0,0,1,3.031,2.18109.61791.61791,0,0,0,.70033.36052,2.94755,2.94755,0,0,1,.63085-.06909,3.28372,3.28372,0,0,1,2.81453,1.74856.61808.61808,0,1,0,1.07142-.61658,4.50526,4.50526,0,0,0-3.88595-2.36843q-.203,0-.40668.02031a4.568,4.568,0,0,0-3.95525-2.49241,4.91114,4.91114,0,0,0-4.61677,5.15065v.41176a2.25284,2.25284,0,0,0,.24793,1.03034h-.454a.618.618,0,1,0,0,1.23608H38.47232a.618.618,0,0,0,0-1.23608Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-5",
    d: "M40.7436,53.867a3.91312,3.91312,0,0,1,4.65719-3.64554.61766.61766,0,0,0,.67331-.337,3.89009,3.89009,0,0,1,3.52359-2.20789,3.93275,3.93275,0,0,1,3.76079,2.82451.61812.61812,0,1,0,1.18746-.34387,5.17856,5.17856,0,0,0-3.90647-3.609l-2.97855-5.02608a.618.618,0,1,0-1.06331.63023l2.553,4.30807a5.19407,5.19407,0,0,0-3.96906,2.47981,5.15307,5.15307,0,0,0-5.35714,3.324,5.14555,5.14555,0,0,0-7.64878,0,5.15307,5.15307,0,0,0-5.35714-3.324,5.194,5.194,0,0,0-3.96885-2.47981l7.58126-12.79352h1.65471v2.67834a2.26623,2.26623,0,1,0,4.53245,0V33.66693h2.93931a.618.618,0,0,0,0-1.23607H36a.61792.61792,0,0,0-.618.618v3.29638a1.03015,1.03015,0,1,1-2.0603,0V33.04889a.618.618,0,0,0-.618-.618H31.10848a6.6343,6.6343,0,0,0,.565-2.67835.20632.20632,0,0,1,.20607-.20606h8.241a.20616.20616,0,0,1,.20607.20606,6.63687,6.63687,0,0,0,.92654,3.38112l1.0566,1.78315a.61811.61811,0,0,0,1.06351-.63023l-1.0566-1.78294a5.39868,5.39868,0,0,1-.754-2.7511,1.44382,1.44382,0,0,0-1.44214-1.44214h-8.241a1.444,1.444,0,0,0-1.44231,1.44214,5.39851,5.39851,0,0,1-.75381,2.7511l-.13006.21951-.01341.02235-8.17716,13.7991A5.12509,5.12509,0,0,0,17.32033,50.749a.61811.61811,0,0,0,1.2198.20078A3.91549,3.91549,0,0,1,25.9259,49.884a.61743.61743,0,0,0,.67331.337,3.91518,3.91518,0,0,1,4.65719,3.646.61771.61771,0,0,0,.50117.57633.59542.59542,0,0,0,.11645.0114.61772.61772,0,0,0,.56214-.36214,3.91422,3.91422,0,0,1,7.12747,0,.61812.61812,0,0,0,1.18-.22559Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-5",
    d: "M54.95441,57.154h-.454a2.25114,2.25114,0,0,0,.24793-1.03v-.41214a4.91111,4.91111,0,0,0-4.61677-5.15065,4.56756,4.56756,0,0,0-3.95525,2.49241c-.13577-.0134-.2717-.02031-.40685-.02031a4.50659,4.50659,0,0,0-3.94958,2.48222.61813.61813,0,0,0,1.08628.59019,3.28964,3.28964,0,0,1,2.8633-1.836,2.94728,2.94728,0,0,1,.63082.06909.61817.61817,0,0,0,.70053-.36052,3.35491,3.35491,0,0,1,3.03075-2.18109,3.68145,3.68145,0,0,1,3.38054,3.91462V56.124a1.03128,1.03128,0,0,1-1.03018,1.03H40.90334a.618.618,0,1,0,0,1.23608H54.95441a.618.618,0,1,0,0-1.23608Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-5",
    d: "M53.30624,35.72728h-.88587a.618.618,0,1,0,0,1.236h.88587a1.03017,1.03017,0,1,1,0,2.06034H43.41686a1.03017,1.03017,0,1,1,0-2.06034h6.75071a.618.618,0,0,0,0-1.236H43.41686a2.26631,2.26631,0,0,0,0,4.53261H53.306a2.26631,2.26631,0,1,0,.0002-4.53261Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-5",
    d: "M35.382,42.11417v6.34565a.618.618,0,0,0,1.23608,0V42.11417a.618.618,0,1,0-1.23608,0Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-5",
    d: "M30.43213,40.97487l-2.93019,4.94459a.618.618,0,1,0,1.0633.63l2.93019-4.94438a.618.618,0,1,0-1.0633-.63019Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-5",
    d: "M40.5044,41.60506l2.93036,4.94438a.618.618,0,1,0,1.0633-.63l-2.93015-4.94459a.6181.6181,0,0,0-1.06351.63019Z"
  })), /*#__PURE__*/React.createElement("path", {
    className: "cls-5",
    d: "M38.38308,54.42339a1.33922,1.33922,0,0,0-.80887.2707,1.80156,1.80156,0,0,0-1.05149-.678,1.3482,1.3482,0,0,0-2.57474.01461,1.34883,1.34883,0,0,0,.39082,2.63955.44933.44933,0,1,0,0-.89865.44985.44985,0,0,1-.02235-.89911.45451.45451,0,0,0,.47191-.44872.44935.44935,0,1,1,.89869,0,.44932.44932,0,0,0,.4493.44914.89975.89975,0,0,1,.89869.89869.44935.44935,0,1,0,.89869,0,.44935.44935,0,0,1,.89869,0,.44935.44935,0,1,0,.89869,0A1.35,1.35,0,0,0,38.38308,54.42339Z"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgVolcanes);
export default __webpack_public_path__ + "static/media/volcanes.3129793b53aed95c7af11dd1557307ad.svg";
export { ForwardRef as ReactComponent };